import { createContext, useContext, useState } from "react";
import {
  fetchClientAndToken,
  fetchClientsIds,
  fetchConfig
} from "../services/tipddy-v2/clients";

let LOCALHOST = "localhost";

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  let actions = {};

  actions.getConfig = async function () {
    /* let domain = window.location.host;
    let token = await wordpresstoken();
    let clients = await fetchClientsIds({ token });

    let client = actions.getClientId({ clients, domain });
    console.log(client) */
    /* 
     */
    console.log(window.location.host)
     let response = await fetchClientAndToken(124201); 
     console.log(response)
    //let config = await fetchConfig({ token:response.token, id: 26793 }); // response.client.ID
    //console.log(config)
    //console.log(client.baseMoodleURL)
    let config = {
      ...response.config,
      baseURL: response.client.baseMoodleURL,
    };

    document.title = config.titulo_interfaz || "Campus virtual";

    localStorage.setItem("config", "stage");
    setConfig({ ...config });
    // console.log({ config });
    return config;
  };

  actions.verifyConfig = async function () {};

  actions.getClientId = ({ clients, domain }) => {
    console.log(clients);
    if (domain.includes(LOCALHOST)) {
      let host = domain.split(":")[0];
      let localhostClient = clients.find((c) =>
        c.baseInterfazURL?.includes(host)
      );
      /* return localhostClient; */

      return {
        ID: 26793,
        baseMoodleURL: 'https://e-aula.academia-tecnigen.cl',
        baseInterfazURL: 'https://participante.academia-tecnigen.cl/'
      }
    }
    
    let isValidClient = clients.find((c) =>
      c.baseInterfazURL?.includes(domain)
    ); 

    if (isValidClient) {
      return isValidClient;
    }
  };

  let value = {
    config,
    getConfig: actions.getConfig,
  };

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);

